import cx from 'classnames';
import { arrayOf, bool, func, number, shape, string } from 'prop-types';
import { campaignState, getBeautyBoxOpenStatus } from '../../../utils/campaignState';
import ReactivateCTA from '../SharedComponents/ReactivateCTA/ReactivateCTA';
import * as styles from './BoxSubscriptionPanel.module.css';

const BoxSubscriptionPanel = ({ boxSubscription, sysdata, products = [] }) => {
  const renderProductItem = (product, idx) => {
    return (
      <div key={product.id} className={styles.productItem}>
        <img
          alt={product.name}
          className={styles.productImage}
          src={product.variants[0].imageUrl}
        />
        <div className={styles.productDetails}>
          <h4 className={styles.productName}>Choice {idx + 1}</h4>
          <span className={styles.productDescription}>{product.name}</span>
        </div>
      </div>
    );
  };

  //TODO: Rename function to make it more generic
  const status = getBeautyBoxOpenStatus(boxSubscription);
  const isOpen = status === campaignState.OPEN;
  const displayProducts = products.length > 0 ? products : [];
  const hasProducts = displayProducts.length > 0 && boxSubscription.choices.length > 0;
  const boxSlug = `${boxSubscription.brandName.toLowerCase().replace(/\s+/g, '-')}-${boxSubscription.name.toLowerCase().replace(/\s+/g, '-')}`;

  return (
    <>
      <div className={styles.panelContainer}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Beauty Box</h1>
        </div>

        {/* Customizations Section */}
        <div className={styles.customizationsSection}>
          <h2 className={styles.customizationsHeader}>Customizations</h2>
          <p className={styles.description}>
            Thanks for submitting your choices! We’re hard at work processing your box now. You can
            view tracking here as soon as it’s available.
          </p>
          <div className={styles.statusContainer}>
            <div className={styles.status}>
              Status: {status || 'Open'}
              <div
                className={cx(styles.statusLight, {
                  [styles.open]: isOpen,
                })}
              />
            </div>
          </div>
        </div>

        {/* Main Container - matches Panel structure */}
        <div className={cx(styles.container, { [styles.centered]: !hasProducts })}>
          <div className={styles.productGridWrapper}>
            {!hasProducts ? (
              <ReactivateCTA
                baseClass="customize"
                title="Customizations are Open!"
                desc="This is where you’ll see your box customizations after you’ve selected them."
                ctaLabel="Customize Now"
                iconClass="fa-hand-holding-box"
                isMobile={sysdata.isMobile}
                isCustomizationFlow
                boxSlug={boxSlug}
              />
            ) : (
              <div className={styles.productGrid}>{displayProducts.map(renderProductItem)}</div>
            )}
          </div>
        </div>
      </div>
      <div className="hor-rule mar-h-40" />
    </>
  );
};

BoxSubscriptionPanel.propTypes = {
  boxSubscription: shape({}).isRequired,
  sysdata: shape({
    boxData: shape({
      customizeCampaignState: shape({}).isRequired,
      customizations: arrayOf(
        shape({
          additionalItems: arrayOf(
            shape({
              quantity: number.isRequired,
              price: number.isRequired,
            }),
          ).isRequired,
          questionType: string.isRequired,
          additionalItemCost: number.isRequired,
        }),
      ).isRequired,
    }).isRequired,
    userData: shape({}).isRequired,
    isMobile: bool.isRequired,
    isProspect: bool.isRequired,
    revealCallback: func.isRequired,
  }).isRequired,
  products: arrayOf(shape({})),
};

BoxSubscriptionPanel.displayName = 'BoxSubscriptionPanel';

export default BoxSubscriptionPanel;
